import { render, staticRenderFns } from "./PageJustView.vue?vue&type=template&id=72361352&scoped=true&"
import script from "./PageJustView.vue?vue&type=script&lang=js&"
export * from "./PageJustView.vue?vue&type=script&lang=js&"
import style0 from "./PageJustView.vue?vue&type=style&index=0&id=72361352&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72361352",
  null
  
)

export default component.exports